<script>
  import Bilde from './bilde.svelte'
  export let bilde
  export let tittel
  export let ledere
  export let punktliste
  export let region
</script>

<div class="boks" data-region={region}>
  <div class="fleks">
    {#if bilde}
      <Bilde {bilde} />
    {/if}
    <h3>{tittel}</h3>
  </div>
  <dl>
    {#each ledere as { rolle, navn }}
      <dt class="inline">{rolle}:</dt>
      <dd class="inline">{navn}</dd>
    {/each}
    <dt>{punktliste.tittel}:</dt>
    <dd>
      <ul>
        {#each punktliste.punkt as punkt}
          <li>{punkt}</li>
        {/each}
      </ul>
    </dd>
  </dl>
</div>

<style>
  .boks {
    display: grid;
    gap: 10px;
    padding: 20px 20px 40px;
    background: var(--dhsa-color-background-secondary);
  }

  .boks :global(img) {
    display: none;
    width: 100px;
    height: auto;
  }

  @media (min-width: 375px) {
    .boks :global(img) {
      display: block;
    }
  }

  .fleks {
    display: flex;
    align-items: center;
  }

  h3 {
    margin: 0;
    font-size: 1.7em; /* Scale with text */
    line-height: 1.13;
    font-weight: var(--nrk-sans-weight-bold);
  }

  dl {
    margin-block: 0.8em;
  }

  dt {
    font-weight: var(--nrk-sans-weight-extrabold);
    line-height: 1.75;
  }

  dd {
    margin: 0;
    text-wrap: pretty;
  }

  dt.inline,
  dd.inline {
    display: inline;
  }

  dt.inline::after {
    content: ' ';
  }

  dd.inline::after {
    content: '\a';
    white-space: pre;
  }

  ul {
    margin: 0;
  }
</style>
